<template>
    <div>
        <sub-menu-faturamento 
            v-if="tipo != 'envio' && tipo != 'auditoria'" 
            :ativo="tipo == 'cancelamento' ? 'autorizar-cancelamentos' : 'guias'" />

        <div class="card dashcard mb-0">
            <div class="card-body">

                <div class="form-row mb-2"> 
                    <div class="col col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load(false)" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input 
                            icon="fa-regular fa-calendar fa-fw"
                            type="select"
                            placeholder="Data da Guia"
                            :optionsList="[
                                { id: 'Z', search: 'Data da Autoriz.' },
                                { id: 'P', search: 'Data do Protocolo' },
                            ]"
                            optionsData="id"
                            v-model="filtros.tipo_data" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <template v-if="tipo == 'cancelamento'">
                            <az-input
                                icon="fa fa-filter"
                                :edicao="false"
                                value="Autorizar Cancelamento">
                            </az-input>

                        </template>

                        <template v-else>

                            <az-input
                                icon="fa fa-filter"
                                type="select"
                                service="status-guia.index"
                                optionsMode="json"
                                optionsData="id"
                                optionsDisplay="display"
                                :optionsList="statusList"
                                placeholder="Todos"
                                v-model="filtros.status">
                            </az-input>

                        </template>
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fa fa-play fa-fw"
                            placeholder="Classificação..."
                            type="select"
                            optionsData="id_classe_procedimento"
                            service="classe_procedimentos.index"
                            optionsMode="aql"
                            v-model="filtros.id_classe_procedimento" />
                    </div>

                </div>

                <div class="form-row mb-2">

                    <div class="col col-12 col-md-2">
                        <az-input
                            :edicao="!$store.state.user.id_unidade_operacao"
                            icon="fa fa-building fa-fw"
                            type="select"
                            placeholder="Todas as Unidades..."
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            v-model="filtros.id_unidade_operacao">
                        </az-input>

                        <div class="input-group mb-1" v-if="false">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa fa-building fa-fw" :class="filtros.id_unidade_operacao ? 'text-success' : ''" aria-hidden="true"></i>
                                </span>
                            </div>
                            <select class="form form-control" v-model="filtros.id_unidade_operacao"
                                :disabled="$store.state.user.id_unidade_operacao > 0">
                                <option value="">Todas as Unidades...</option>
                                <option v-for="(und, iux) in $util.unidades_com_tags(false, true)" 
                                    :value="und.id_unidade_operacao" :key="iux">{{ und.search }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fas fa-concierge-bell"
                            type="select"
                            placeholder="Todas as Recepções..."
                            :optionsList="lista_recepcoes"
                            optionsData="id_recepcao"
                            :edicao="filtros.id_unidade_operacao > 0"
                            v-model="filtros.id_recepcao" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input icon="fas fa-user-md fa-fw" 
                            type="select" 
                            optionsMode="aql"
                            service="medicos.index"
                            optionsName="medicos-guia"
                            optionsData="id_pessoa"
                            placeholder="Todos os Executantes..."
                            :optionsParm="{ ativos: true, classes: true }"
                            v-model="filtros.id_medico" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="far fa-credit-card"
                            type="select" 
                            optionsMode="aql"
                            optionsData="id_operadora"
                            optionsDisplay="st_operadora"
                            service="operadoras.index"
                            :optionsParm="{ 
                                fatura: true,
                                classes: true,
                                lista: true
                            }"
                            optionsName="operadoras-para-fatura-2"
                            placeholder="Operadora..."
                            v-model="filtros.id_operadora">
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fas fa-file-contract"
                            type="autocomplete" 
                            optionsMode="aql"
                            optionsData="id_contrato_operadora"
                            optionsDisplay="search"
                            service="contrato_operadoras.index"
                            :optionsParm="{ id_operadora: filtros.id_operadora, guias: true }"
                            optionsName="contratos-busca-guia"
                            placeholder="Contrato..."
                            :edicao="filtros.id_operadora ? true : false"
                            v-model="filtros.id_contrato_operadora">
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fas fa-file-powerpoint"
                            type="autocomplete" 
                            optionsMode="aql"
                            optionsData="id_plano"
                            optionsDisplay="st_plano"
                            service="planos.index"
                            :optionsParm="{ id_operadora: filtros.id_operadora }"
                            :edicao="filtros.id_operadora ? true : false"
                            optionsName="planos"
                            placeholder="Plano..."
                            v-model="filtros.id_plano">
                        </az-input>
                    </div>

                </div>

                <div class="form-row">

                    <div class="col col-12 col-md-4" v-if="exibir_responsavel">
                        <az-input
                            icon="fa fa-user"
                            type="select" 
                            optionsMode="aql"
                            optionsData="id_usuario"
                            optionsDisplay="search"
                            optionsName="usuarios-recepcao"
                            service="usuarios.index"
                            :optionsParm="{ perfil: 4, ativos: true }"
                            placeholder="Todos os Responsáveis..."
                            v-model="filtros.id_usuario">
                            <template v-slot:buttonposb>
                                <print-export printid="lista-guias" :dados="dadosFormatados" />
                            </template>
                        </az-input>
                    </div>

                    <template v-else>
                        
                        <div class="col col-12 col-md-2">
                            <az-input 
                                type="checkbox-group"
                                label="Guias Zeradas"
                                v-model="filtros.guia_zerada" />
                        </div>

                        <div class="col col-12 col-md-2">
                            <az-input
                                type="select"
                                icon="fa fa-filter"
                                placeholder="Todos (cód autoriz)..."
                                optionsData="id"
                                :optionsList="[
                                    { id: 'S', search: 'Com cód. de autoriz.'}, 
                                    { id: 'N', search: 'Sem cód. de autoriz.'}, 
                                ]"
                                v-model="filtros.filtro_senha" />
                        </div>

                    </template>

                    <div class="col col-12 col-md-4" class2="exibir_responsavel ? 'col-md-4' : 'col-md-6'">
                        <az-input 
                            v-if="filtros.op_filtro == 'PAC'"
                            placeholder="Selecionar paciente..."
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="paciente" 
                            :optimized_ac="true">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa-solid fa-user fa-fw" v-if="filtros.op_filtro == 'PAC'"></i>
                                        <i class="fa-solid fa-play fa-fw" v-if="filtros.op_filtro == 'PROC'"></i>
                                        <i class="fa-solid fa-filter fa-fw" v-if="filtros.op_filtro == 'STAT'"></i>
                                        <i class="fa-solid fa-code fa-fw" v-if="filtros.op_filtro == 'COD'"></i>
                                        <i class="fa-solid fa-magnifying-glass fa-fw" v-if="filtros.op_filtro == 'TXTL'"></i>
                                        <i class="fa-solid fa-box-open fa-fw" v-if="filtros.op_filtro == 'SUP'"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PAC'">
                                            <i class="fa-solid fa-user fa-fw mr-2"></i>
                                            Paciente
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PROC'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'GRP'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Grupo de Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'COD'">
                                            <i class="fa-solid fa-code fa-fw mr-2"></i>
                                            Código TUSS / SUS / Convênio
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'STAT'">
                                            <i class="fa-solid fa-filter fa-fw mr-2"></i>
                                            Status de Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'TXTL'" v-if="impressao_laudos">
                                            <i class="fa-solid fa-magnifying-glass fa-fw mr-2"></i>
                                            Texto no Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'SUP'">
                                            <i class="fa-solid fa-box-open fa-fw mr-2"></i>
                                            Baixa de Estoque
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PCS'">
                                            <i class="fa-solid fa-layer-group fa-fw mr-2"></i>
                                            Pacote de Sessão
                                        </a>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:buttonposb>
                                <print-export printid="lista-guias" :dados="dadosFormatados" />
                            </template>
                        </az-input>

                        <az-input
                            v-else-if="filtros.op_filtro == 'GRP'"
                            placeholder="Todos os grupos..."
                            type="autocomplete"
                            service="procedimento_grupos.index"
                            optionsMode="aql"
                            v-model="filtros.grupo"
                            ref="info_grupo">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa-solid fa-play fa-fw" v-if="filtros.op_filtro == 'GRP'"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PAC'">
                                            <i class="fa-solid fa-user fa-fw mr-2"></i>
                                            Paciente
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PROC'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'GRP'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Grupo de Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'COD'">
                                            <i class="fa-solid fa-code fa-fw mr-2"></i>
                                            Código TUSS / SUS / Convênio
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'STAT'">
                                            <i class="fa-solid fa-filter fa-fw mr-2"></i>
                                            Status de Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'TXTL'" v-if="impressao_laudos">
                                            <i class="fa-solid fa-magnifying-glass fa-fw mr-2"></i>
                                            Texto no Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'SUP'">
                                            <i class="fa-solid fa-box-open fa-fw mr-2"></i>
                                            Baixa de Estoque
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PCS'">
                                            <i class="fa-solid fa-layer-group fa-fw mr-2"></i>
                                            Pacote de Sessão
                                        </a>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:buttonposb>
                                <print-export printid="lista-guias" :dados="dadosFormatados" />
                            </template>
                        </az-input>

                        <az-input
                            v-else-if="filtros.op_filtro == 'PROC'"
                            placeholder="Todos os procedimentos..."
                            type="autocomplete"
                            service="procedimentos.index"
                            optionsMode="aql"
                            optionsName="procedimentos.index.guia.ativos"
                            :optionsParm="{ ativos: true }"
                            v-model="filtros.procedimento"
                            ref="info_procedimento">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa-solid fa-user fa-fw" v-if="filtros.op_filtro == 'PAC'"></i>
                                        <i class="fa-solid fa-play fa-fw" v-if="filtros.op_filtro == 'PROC'"></i>
                                        <i class="fa-solid fa-filter fa-fw" v-if="filtros.op_filtro == 'STAT'"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PAC'">
                                            <i class="fa-solid fa-user fa-fw mr-2"></i>
                                            Paciente
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PROC'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'GRP'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Grupo de Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'COD'">
                                            <i class="fa-solid fa-code fa-fw mr-2"></i>
                                            Código TUSS / SUS / Convênio
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'STAT'">
                                            <i class="fa-solid fa-filter fa-fw mr-2"></i>
                                            Status de Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'TXTL'" v-if="impressao_laudos">
                                            <i class="fa-solid fa-magnifying-glass fa-fw mr-2"></i>
                                            Texto no Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'SUP'">
                                            <i class="fa-solid fa-box-open fa-fw mr-2"></i>
                                            Baixa de Estoque
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PCS'">
                                            <i class="fa-solid fa-layer-group fa-fw mr-2"></i>
                                            Pacote de Sessão
                                        </a>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:buttonposb>
                                <print-export printid="lista-guias" :dados="dadosFormatados" />
                            </template>
                        </az-input>

                        <az-input
                            v-else-if="filtros.op_filtro == 'COD'"
                            placeholder="Código TUSS / SUS / Convênio..."
                            v-model="filtros.codigo"
                            ref="info_codigo">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa-solid fa-code fa-fw"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PAC'">
                                            <i class="fa-solid fa-user fa-fw mr-2"></i>
                                            Paciente
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PROC'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'GRP'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Grupo de Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'COD'">
                                            <i class="fa-solid fa-code fa-fw mr-2"></i>
                                            Código TUSS / SUS / Convênio
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'STAT'">
                                            <i class="fa-solid fa-filter fa-fw mr-2"></i>
                                            Status de Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'TXTL'" v-if="impressao_laudos">
                                            <i class="fa-solid fa-magnifying-glass fa-fw mr-2"></i>
                                            Texto no Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'SUP'">
                                            <i class="fa-solid fa-box-open fa-fw mr-2"></i>
                                            Baixa de Estoque
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PCS'">
                                            <i class="fa-solid fa-layer-group fa-fw mr-2"></i>
                                            Pacote de Sessão
                                        </a>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:buttonposb>
                                <print-export printid="lista-guias" :dados="dadosFormatados" />
                            </template>
                        </az-input>

                        <az-input
                            v-else-if="filtros.op_filtro == 'PCS'"
                            placeholder="Pacote de Sessão..."
                            type="select"
                            :optionsList="[
                                { id: 'C', search: 'Completo' },
                                { id: 'P', search: 'Em Andamento' },
                            ]"
                            optionsData="id"
                            v-model="filtros.tipo_filtro_pacote"
                            ref="info_pacote">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa-solid fa-layer-group fa-fw"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PAC'">
                                            <i class="fa-solid fa-user fa-fw mr-2"></i>
                                            Paciente
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PROC'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'GRP'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Grupo de Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'COD'">
                                            <i class="fa-solid fa-code fa-fw mr-2"></i>
                                            Código TUSS / SUS / Convênio
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'STAT'">
                                            <i class="fa-solid fa-filter fa-fw mr-2"></i>
                                            Status de Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'TXTL'" v-if="impressao_laudos">
                                            <i class="fa-solid fa-magnifying-glass fa-fw mr-2"></i>
                                            Texto no Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'SUP'">
                                            <i class="fa-solid fa-box-open fa-fw mr-2"></i>
                                            Baixa de Estoque
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PCS'">
                                            <i class="fa-solid fa-layer-group fa-fw mr-2"></i>
                                            Pacote de Sessão
                                        </a>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:buttonposb>
                                <print-export printid="lista-guias" :dados="dadosFormatados" />
                            </template>
                        </az-input>

                        <az-input
                            v-else-if="filtros.op_filtro == 'STAT'"
                            type="autocomplete"
                            optionsMode="aql"
                            service="status_laudos.index"
                            optionsData="id_status_laudo"
                            placeholder="Todos os status de laudo..."
                            v-model="filtros.id_status_laudo"
                            ref="info_status">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa-solid fa-filter fa-fw"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PAC'">
                                            <i class="fa-solid fa-user fa-fw mr-2"></i>
                                            Paciente
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PROC'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'GRP'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Grupo de Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'COD'">
                                            <i class="fa-solid fa-code fa-fw mr-2"></i>
                                            Código TUSS / SUS / Convênio
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'STAT'">
                                            <i class="fa-solid fa-filter fa-fw mr-2"></i>
                                            Status de Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'TXTL'" v-if="impressao_laudos">
                                            <i class="fa-solid fa-magnifying-glass fa-fw mr-2"></i>
                                            Texto no Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'SUP'">
                                            <i class="fa-solid fa-box-open fa-fw mr-2"></i>
                                            Baixa de Estoque
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PCS'">
                                            <i class="fa-solid fa-layer-group fa-fw mr-2"></i>
                                            Pacote de Sessão
                                        </a>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:buttonposb>
                                <print-export printid="lista-guias" :dados="dadosFormatados" />
                            </template>
                        </az-input>

                        <az-input
                            v-else-if="filtros.op_filtro == 'TXTL'"
                            type="text"
                            placeholder="Todos no laudo..."
                            v-model="filtros.texto_laudo"
                            ref="info_status">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa-solid fa-magnifying-glass"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PAC'">
                                            <i class="fa-solid fa-user fa-fw mr-2"></i>
                                            Paciente
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PROC'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'GRP'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Grupo de Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'COD'">
                                            <i class="fa-solid fa-code fa-fw mr-2"></i>
                                            Código TUSS / SUS / Convênio
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'STAT'">
                                            <i class="fa-solid fa-filter fa-fw mr-2"></i>
                                            Status de Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'TXTL'" v-if="impressao_laudos">
                                            <i class="fa-solid fa-magnifying-glass fa-fw mr-2"></i>
                                            Texto no Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'SUP'">
                                            <i class="fa-solid fa-box-open fa-fw mr-2"></i>
                                            Baixa de Estoque
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PCS'">
                                            <i class="fa-solid fa-layer-group fa-fw mr-2"></i>
                                            Pacote de Sessão
                                        </a>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:buttonposb>
                                <print-export printid="lista-guias" :dados="dadosFormatados" />
                            </template>
                        </az-input>

                        <az-input
                            v-else-if="filtros.op_filtro == 'SUP'"
                            type="select"
                            placeholder="Baixa de Estoque..."
                            :optionsList="[
                                { id: 'S', search: 'Baixa realizada' },
                                { id: 'N', search: 'Baixa pendente' },
                                { id: 'R', search: 'Solicitação realizada' },
                                { id: 'I', search: 'Solicitação não realizada' },
                            ]"
                            optionsData="id"
                            v-model="filtros.sup"
                            ref="info_sup">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa-solid fa-box-open fa-fw"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PAC'">
                                            <i class="fa-solid fa-user fa-fw mr-2"></i>
                                            Paciente
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PROC'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'GRP'">
                                            <i class="fa-solid fa-play fa-fw mr-2"></i>
                                            Grupo de Procedimento
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'COD'">
                                            <i class="fa-solid fa-code fa-fw mr-2"></i>
                                            Código TUSS / SUS / Convênio
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'STAT'">
                                            <i class="fa-solid fa-filter fa-fw mr-2"></i>
                                            Status de Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'TXTL'" v-if="impressao_laudos">
                                            <i class="fa-solid fa-magnifying-glass fa-fw mr-2"></i>
                                            Texto no Laudo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'SUP'">
                                            <i class="fa-solid fa-box-open fa-fw mr-2"></i>
                                            Baixa de Estoque
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="filtros.op_filtro = 'PCS'">
                                            <i class="fa-solid fa-layer-group fa-fw mr-2"></i>
                                            Pacote de Sessão
                                        </a>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:buttonposb>
                                <print-export printid="lista-guias" :dados="dadosFormatados" />
                            </template>
                        </az-input>

                        <az-input 
                            v-if="false"
                            placeholder="Selecionar paciente..."
                            icon="fas fa-user"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="paciente" 
                            :optimized_ac="true">
                            <template v-slot:buttonposb>
                                <print-export printid="lista-guias" :dados="dadosFormatados" />
                            </template>
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-4" class2="exibir_responsavel ? 'col-md-4' : 'col-md-6'">
                        <az-input
                            icon="fa fa-search"
                            type="text"
                            v-model="pesquisar"
                            :shortkey="['ctrl', 'p']"
                            placeholder="Pesquisar por..."
                            @input="refresh_se_necessario()"
                            @onEnter="buscar_ou_selecionar()">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="tipo == 'envio'">
                                    <relatorios-linkados
                                        ref="linkados"
                                        pagina="recepcao-fechamento"
                                        :outros="[
                                            { title: 'Protocolo', callback: consultar_recebimentos },
                                        ]"
                                        :parms="{ 
                                            unidade: filtros.id_unidade_operacao,
                                            usuario: $store.state.user.id_usuario,
                                            guia_id: exibicao ? exibicao.map(guia => guia.id_guia) : null,
                                            protocolo_id: protocolo_id, 
                                            backlink: '/recepcao/envio'
                                        }"
                                    />
                                </div>
                                <!-- To-do -->
                                <div class="input-group-append" v-else>
                                    <relatorios-linkados
                                        ref="linkados"
                                        pagina="guias-faturamento"
                                        :outros="[
                                            { title: 'Protocolo', callback: consultar_recebimentos },
                                        ]"
                                        :parms="{ 
                                            unidade: filtros.id_unidade_operacao,
                                            guia_id: exibicao ? exibicao.map(guia => guia.id_guia) : null,
                                            backlink: '/faturamento/guias'
                                        }"
                                    />
                                </div>

                                <button type="button" class="btn btn-outline-primary ml-1" title="Adicionar Filtros." @click="incluir_filtro()">
                                    <i class="fa-solid fa-filter"></i>
                                    <span class="badge badge-primary ml-1" v-if="lista_add_filtros && lista_add_filtros.length">
                                        {{ lista_add_filtros.length }}
                                    </span>
                                </button>
                            </template>
                        </az-input>
                    </div>
                </div>

            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && exibicao && exibicao.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <div class="alert alert-info" v-if="filtros_selec && filtros_selec.status == 'DI'">
            <div class="row form-row">
                <div class="col col-12" :class="tipo == 'envio' ? '' : 'col-md-8'">
                    <span v-if="tipo == 'envio'">
                        Selecione as guias desejadas para registrar o protocolo de envio para o faturamento.
                    </span>
                    <span v-else>
                        Selecione as guias desejadas para registrar o recebimento no faturamento.
                    </span>
                </div>
                <div class="col col-12 col-md-4" v-if="tipo != 'envio'">
                    <az-input 
                        sizing="sm"
                        type="button-group"
                        :optionsList="[
                            { id: 'T', search: 'Todas' },
                            { id: 'S', search: 'Sem Pendências' },
                            { id: 'R', search: 'Resolvidas' },
                        ]"
                        optionsData="id"
                        optionsDisplay="search" 
                        v-model="filtros.tipo_disponivel" />
                </div>
            </div>
        </div>

        <div v-if="selected && status_laudo && status_laudo.fl_nao_coletar && !status_laudo.fl_pronto">
            <div class="alert alert-warning d-flex justify-content-between">
                <div>
                    <i class="fa-solid fa-triangle-exclamation fa-fw mr-2"></i>
                    Guias com Exames Pendentes de Amostra 
                </div>
                <div>
                    <button type="button" class="btn btn-sm btn-outline-secondary mr-1" :disabled="desabilitar('cancelar-exames')" @click="acao_exames_pendentes(false, true)">
                        Separar Exames Pendentes
                    </button>

                    <button type="button" class="btn btn-sm btn-outline-secondary mr-1" :disabled="desabilitar('cancelar-exames')" @click="acao_exames_pendentes(true)">
                        Zerar Exames Pendentes
                    </button>

                    <button type="button" class="btn btn-sm btn-outline-danger" :disabled="desabilitar('cancelar-exames')" @click="acao_exames_pendentes()">
                        Cancelar Exames Pendentes
                    </button>
                </div>
            </div>
        </div> 

        <div v-if="exibicao && exibicao.length">

            <div v-if="protocolo_para_imprimir" class="mb-3">
                <button type="button" class="btn btn-sm btn-outline-primary" @click="$refs.receber.selecionar(protocolo_para_imprimir)">
                    <i class="fa fa-print mr-2" aria-hidden="true"></i>
                    Imprimir Protocolo
                </button>
            </div>

            <!-- Relação de @Guias -->
            <div id="lista-guias">
            
                <table class="table table-hover table-sm table-responsive-md bg-white w3-animate-opacity cabecalho-fixo">
                    <thead>
                        <tr>
                            <td colspan="20" class="p-0">
                                <div class="d-none d-print-block">
                                    <cabecalho-generico titulo="Guias">
                                    </cabecalho-generico>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <th>Id</th>
                            <table-th title="Data" v-model="ordem" sortby="dt_criacao"></table-th>
                            <table-th title="Guia" v-model="ordem" sortby="guia_formatada"></table-th>
                            <table-th title="Tipo" v-model="ordem" sortby="nome"></table-th>
                            <table-th title="Paciente" v-model="ordem" sortby="atendimento.paciente.st_nome"></table-th>
                            <table-th title="Prof." v-model="ordem" sortby="atendimento.medico.st_nome_exibicao"></table-th>
                            <table-th title="Operadora" v-model="ordem" sortby="plano.operadora.st_operadora"></table-th>
                            <table-th title="Prot" v-model="ordem" sortby="protocolos" v-if="exibir_protocolo"></table-th>
                            <th class="text-right">{{ show_valor_consumo ? 'Mat/Med/Taxa' : 'Valor' }}</th>
                            <template v-if="filtros.status != 'AC' && !show_valor_consumo">
                                <th class="text-right">Glosado</th>
                                <th class="text-right">Recebido</th>
                                <th class="text-right text-nowrap text-truncate">A Receber</th>
                            </template>
                            <td class="text-center">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="selectAll" id="defaultCheck1"
                                        @change="onSelectAll ()">
                                </div>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-primary">
                            <td></td>
                            <td></td>
                            <td colspan="5">Total</td>
                            <td>
                                <small v-if="guias && guias.last_page > 1">
                                    {{ guias.from }} - {{ guias.to }}  / {{ guias.total }} guias
                                </small>
                                <small v-else>
                                    {{ exibicao.length }} {{ exibicao.length > 1 ? 'guias' : 'guia' }}
                                </small>
                            </td>
                            <td v-if="exibir_protocolo"></td>
                            <td class="text-right">
                                <span v-if="!show_valor_consumo">{{ $util.formatMoeda(valor_total.total) }}</span>
                                <span v-else>{{ $util.formatMoeda(valor_total.consumo) }}</span>
                            </td>
                            <template v-if="filtros.status != 'AC' && !show_valor_consumo">
                                <td class="text-right text-danger">{{ $util.formatMoeda(valor_total.glosado) }}</td>
                                <td class="text-right text-primary">
                                    {{ $util.formatMoeda(valor_total.recebido) }}
                                    <div v-if="valor_total.a_mais" class="small text-muted"  title="Recebido a mais.">
                                        <i class="fa-solid fa-circle-plus mr-1"></i> {{ $util.formatMoeda(valor_total.a_mais) }}
                                    </div>
                                </td>
                                <td class="text-right text-success">{{ $util.formatMoeda(valor_total.a_receber) }}</td>
                            </template>
                            <td></td>
                        </tr>
                        <tr class="table-info">
                            <td></td>
                            <td></td>
                            <td colspan="5">Selecionado</td>
                            <td>
                                <small>
                                    {{ selecteds.length }} {{ selecteds.length > 1 ? 'guias' : 'guia' }}
                                </small>
                            </td>
                            <td v-if="exibir_protocolo"></td>
                            <td class="text-right">
                                <span v-if="show_valor_consumo">
                                    {{ $util.formatMoeda(valor_selecionado.consumo) }}
                                </span>
                                <span v-else>
                                    {{ $util.formatMoeda(valor_selecionado.total) }}
                                </span>
                            </td>
                            <template v-if="filtros.status != 'AC' && !show_valor_consumo"> 
                                <td class="text-right text-danger">{{ $util.formatMoeda(valor_selecionado.glosado) }}</td>
                                <td class="text-right text-primary">
                                    {{ $util.formatMoeda(valor_selecionado.recebido) }}
                                    <div v-if="valor_selecionado.a_mais" class="small text-muted"  title="Recebido a mais.">
                                        <i class="fa-solid fa-circle-plus mr-1"></i> {{ $util.formatMoeda(valor_selecionado.a_mais) }}
                                    </div>
                                </td>
                                <td class="text-right text-success">{{ $util.formatMoeda(valor_selecionado.a_receber) }}</td>
                            </template>
                            <td></td>
                        </tr>
                        <template v-for="(guia, index) in exibicao">
                            <tr :key="index" :class="guia.selected ? 'table-secondary' : ''" class="table-light" v-if="true">
                                <td>
                                    <span class="badge" :class="'badge-' + guia.status_color"
                                        data-toggle="tooltip" data-placement="top" :title="guia.status_guia">
                                        {{ guia.ch_status }}
                                    </span>
                                </td>
                                <td>
                                    <small>
                                        <a href="#" @click.prevent="abrir_atendimento(guia)" class="card-link">
                                            #{{ guia.id_atendimento }}
                                        </a>
                                        <a href="#" @click.prevent v-if="guia.atendimento.marcacao.arquivos.length">
                                            <i class="fa-solid fa-paperclip ml-1" title="Arquivos."></i>
                                        </a>
                                    </small>
                                </td>
                                <td>
                                    <span class="small">
                                        {{ getFormatDate (guia.dt_criacao, 'DD/MM/YYYY') }}
                                    </span>
                                    <div class="badge badge-warning" v-if="guia.dt_criacao.substr(0,10) != guia.atendimento.dt_inicio.substr(0,10)">
                                        Atd.: {{ getFormatDate (guia.atendimento.dt_inicio, 'DD/MM') }}
                                    </div>
                                </td>
                                <td>
                                    <small>
                                        <a href="#" @click.prevent="editar (guia)">
                                            {{ guia.guia_formatada }}
                                        </a>
                                        <div class="text-muted" v-if="exibir_matricula && guia.st_numero" title="No. Guia Atribuido pela Operadora">
                                            {{ guia.st_numero }}
                                        </div>
                                    </small>
                                </td>
                                <td class="text-nowrap">
                                    <small>
                                        <a href="#" @click.prevent="filtrar_tipo_guia(guia.ch_tipo_guia)" class="card-link">
                                            {{ guia.nome }}
                                        </a>
                                    </small>
                                    <span class="badge badge-secondary">
                                        {{ guia.valor_total.items }}
                                    </span>
                                    <span class="ml-1" v-if="guia.ch_tipo_guia == 'A' && !guia.st_codigo_autorizacao" title="Número da APAC não informado.">
                                        <i class="fa-solid fa-circle-question text-warning"></i>
                                    </span>

                                    <span class="ml-1" v-else-if="guia.ch_tipo_guia == 'I' && !guia.st_codigo_autorizacao" title="Número da AIH não informado.">
                                        <i class="fa-solid fa-circle-question text-warning"></i>
                                    </span>

                                    <span class="ml-1" v-else-if="guia.ch_tipo_guia != 'A' && guia.ch_tipo_guia != 'I' && guia.st_codigo_autorizacao" :title="'Código de Autorização (Senha) preenchido: ' + guia.st_codigo_autorizacao">
                                        <i class="fa-solid fa-circle-check" :class="guia.st_codigo_autorizacao != '0' ? 'text-success' : 'text-warning'"></i>
                                    </span>

                                    <span class="badge badge-primary ml-1" v-if="false && filtros.tipo_data == 'Z' && guia.dt_autorizacao">
                                        Aut: {{ getFormatDate(guia.dt_autorizacao, 'DD/MM') }}
                                    </span>

                                    <div class="small text-muted" v-if="exibir_matricula && guia.st_codigo_autorizacao" title="Senha">
                                        {{ guia.st_codigo_autorizacao }}
                                    </div>
                                </td>
                                <td class2="text-nowrap text-truncate">
                                    <small>
                                        <a href="#" @click.prevent="filtrar_paciente(guia.atendimento.paciente)" class="card-link">
                                            {{ guia.atendimento.paciente.st_nome }}
                                        </a>
                                        
                                        <span class="text-success ml-1" 
                                            data-toggle="tooltip" data-placement="top" title="Pendência Resolvida"
                                            v-if="guia.ch_status == 'DI' && guia.guia_pendencias && guia.guia_pendencias.length == 1 
                                                && !guia.guia_pendencias[0].fl_ativo">
                                            <i class="fas fa-check-circle"></i>
                                        </span>
                                    </small>
                                    <div class="small text-muted" v-if="exibir_matricula && guia.ch_tipo_guia != 'A' && guia.ch_tipo_guia != 'B' && guia.atendimento.st_numero_carteira" title="Matrícula">
                                        {{ guia.atendimento.st_numero_carteira }}
                                    </div>
                                    <div class="small text-muted" v-else-if="exibir_matricula && ( guia.ch_tipo_guia == 'A' || guia.ch_tipo_guia == 'B' ) && guia.atendimento.paciente.paciente_unidade && guia.atendimento.paciente.paciente_unidade.st_sus" title="CNS">
                                        <a href="#" @click.prevent="copiar_texto(guia.atendimento.paciente.paciente_unidade.st_sus, 'CNS do paciente copiado para área de transferência.')" class="card-link">
                                            CNS: {{ guia.atendimento.paciente.paciente_unidade.st_sus }}
                                        </a>
                                    </div>
                                </td>
                                <td class2="text-nowrap text-truncate">
                                    <small>
                                        <span v-if="guia.id_medico_faturar">
                                            {{ guia.medico_faturar.st_nome_exibicao }}*
                                        </span>
                                        <span v-else>
                                            {{ guia.atendimento.medico.st_nome_exibicao }}
                                        </span>
                                        <span class="badge badge-secondary" v-if="$store.state.unidade.unidade_operacaos.length > 1 && guia.atendimento.unidade_operacao && guia.atendimento.unidade_operacao.st_sigla">
                                            {{ guia.atendimento.unidade_operacao.st_sigla }}
                                        </span>
                                    </small>

                                    <div class="small text-muted" v-if="exibir_matricula && ( guia.ch_tipo_guia == 'A' || guia.ch_tipo_guia == 'B' ) && guia.atendimento.medico" title="Número no Conselho">
                                        <a href="#" @click.prevent="copiar_texto(guia.atendimento.medico.in_numero_conselho, 'Número no Conselho copiado para área de transferência')" class="card-link" v-if="guia.atendimento.medico.conselho && guia.atendimento.medico.in_numero_conselho">
                                            {{ guia.atendimento.medico.conselho.st_sigla }} {{ guia.atendimento.medico.in_numero_conselho }}-{{ guia.atendimento.medico.estado_conselho ? guia.atendimento.medico.estado_conselho.st_sigla : '' }}
                                        </a>
                                    </div>  
                                    
                                    <div v-else-if="exibir_procedimento && guia.atendimento_procedimento_guias && guia.atendimento_procedimento_guias.length > 1 && outros_medicos(guia)" class="small text-muted">
                                        {{ outros_medicos(guia) }}
                                    </div>
                                </td>
                                <td class2="text-nowrap text-truncate">
                                    <small>
                                        {{ guia.plano.operadora.st_operadora }}
                                        <small class="text-muted" v-if="guia.plano.operadora.st_operadora != guia.plano.search">
                                            {{ guia.plano.search.slice(guia.plano.operadora.st_operadora.length + 3) }}
                                        </small>
                                        <span class="badge badge-secondary ml-1" v-if="guia.id_contrato_operadora"
                                            data-toggle2="tooltip" data-placement2="top" 
                                            :title="'Contrato: ' + 
                                                ( guia.contrato_operadora && guia.contrato_operadora.st_numero_prestador ? guia.contrato_operadora.st_numero_prestador : 'CNPJ' ) + 
                                                ' - ' + 
                                                ( guia.contrato_operadora && guia.contrato_operadora.st_descricao_arquivo_contrato ? guia.contrato_operadora.st_descricao_arquivo_contrato : '' )">
                                            #{{ guia.id_contrato_operadora }}
                                        </span>
                                    </small>

                                    <div class="small text-muted" v-if="exibir_matricula && ( guia.ch_tipo_guia == 'A' || guia.ch_tipo_guia == 'B' ) && guia.atendimento_procedimento_guias && guia.atendimento_procedimento_guias.length" title="Código SUS">
                                        <div v-for="(apg, ipg) in guia.atendimento_procedimento_guias" :key="index + '.' + ipg">
                                            <a href="#" @click.prevent="copiar_texto(apg.atendimento_procedimento.procedimento.st_codigo_sus, 'Código SUS copiado para área de transferência')" class="card-link" v-if="apg.atendimento_procedimento && apg.atendimento_procedimento.procedimento">
                                                {{ apg.atendimento_procedimento.procedimento.st_codigo_sus }}
                                            </a>
                                        </div>
                                    </div>                                    

                                    <div class="small text-muted" v-if="exibir_procedimento && guia.atendimento_procedimento_guias && guia.atendimento_procedimento_guias.length" title="Procedimentos">
                                        <div v-for="(apg, ipg) in guia.atendimento_procedimento_guias" :key="index + '.' + ipg">
                                            {{ apg.atendimento_procedimento.procedimento.search }}
                                            <span class="badge badge-light" v-if="apg.in_quantidade > 1">x{{ apg.in_quantidade }}</span>
                                        </div>
                                    </div>    

                                    <div class="small text-muted" v-if="false && exibir_protocolo && guia.guia_recebimentos && guia.guia_recebimentos.length" title="Protocolos">
                                        {{ guia.guia_recebimentos.map((gr) => gr.protocolo_id).join(', ') }}
                                    </div>    
                                </td>
                                <td v-if="exibir_protocolo" class="small text-muted">
                                    {{ guia.protocolos }}
                                </td>
                                <td class="text-right">
                                    <span v-if="show_valor_consumo">
                                        {{ $util.formatMoeda(guia.valor_total.consumo) }}
                                    </span>
                                    <span v-else>
                                        {{ $util.formatMoeda(guia.valor_total.total) }}
                                    </span>
                                </td>

                                <template v-if="filtros.status != 'AC' && !show_valor_consumo"> 
                                    <td class="text-right" :class="guia.valor_total.glosado ? 'text-danger' : 'text-muted'">
                                        {{ $util.formatMoeda(guia.valor_total.glosado) }}
                                    </td>
                                    <td class="text-right" :class="guia.valor_total.recebido ? 'text-primary' : 'text-muted'">
                                        {{ $util.formatMoeda(guia.valor_total.recebido ) }}
                                        <div v-if="guia.valor_total.a_mais" class="small text-muted"  title="Recebido a mais.">
                                            <i class="fa-solid fa-circle-plus mr-1"></i> {{ $util.formatMoeda(guia.valor_total.a_mais) }}
                                        </div>
                                    </td>
                                    <td class="text-right" :class="guia.valor_total.a_receber ? 'text-success' : 'text-muted'">
                                        {{ $util.formatMoeda(guia.valor_total.a_receber ) }}
                                    </td>
                                </template>
                                    
                                <td class="text-center">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" v-model="guia.selected" id="defaultCheck1"
                                            @change="select_item ()">
                                    </div>
                                </td>
                            </tr>
                            <template v-if="guia.guia_motivo_glosa_pendentes && guia.guia_motivo_glosa_pendentes.length">
                                <tr v-for="(pend, ipx) in guia.guia_motivo_glosa_pendentes" :key="index + '.' + ipx">
                                    <td colspan="2"></td>
                                    <td :colspan="exibir_protocolo ? 11 : 10" class="small">
                                        <i class="fa fa-caret-right mr-1" aria-hidden="true"></i>
                                        {{ pend.motivo_glosa.search }}

                                        <span v-if="pend.responsavel">
                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                            {{ pend.responsavel.st_login }}
                                        </span>

                                        <div v-if="pend.st_observacoes" class="text-muted">
                                            {{ pend.st_observacoes }}
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>

            <div v-if="filtros.status != 'AC'">
                <az-input
                    sizing="sm"
                    type="checkbox-group"
                    label="Exibir Valor de Mat/Met/Taxas"
                    v-model="show_valor_consumo" />
            </div>

            <br><br><br>

            <nav class="navbar fixed-bottom navbar-light bg-light" v-if="selected">
                <a class="navbar-brand" href="#">
                    <span v-if="isNaN(progresso)">Opções</span>
                    <div style="width: 150px;" v-else>
                        <ProgressBar :value="progresso" :showValue="true">
                            {{ progresso }}%
                        </ProgressBar>
                    </div>
                </a>

                <template v-if="filtros.status == 'AC'">
                    <div class='mr-3'> 
                        <button class="btn btn-success btn-sm ml-1" type="button" 
                            data-toggle="tooltip" data-placement="top" title="Confirmar Cancelamento"
                            @click="confirmarCancelamento (true)">
                            <i class="fa fa-check" aria-hidden="true"></i>
                        </button>
                        <button class="btn btn-danger btn-sm ml-1" type="button" 
                            data-toggle="tooltip" data-placement="top" title="Negar Cancelamento"
                            @click="confirmarCancelamento (false)">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                    </div>
                </template>
                <template v-else-if="tipo == 'envio'">
                            <button v-if="impressao_laudos" title="Imprimir Laudos" class="btn btn-sm btn-primary ml-1" type="button" @click="imprimir_laudos()">
                                <i class="fa-solid fa-print"></i>
                            </button>
                    <div class='mr-3'> 
                        <button class="btn btn-sm ml-1" type="button"
                            :class="desabilitar('pendencia-recepcao') ? 'btn-outline-secondary' : 'btn-warning'"
                            data-toggle="tooltip" data-placement="top" title="Adicionar Pendência"
                            :disabled="desabilitar('pendencia-recepcao')" @click="pendencia ()">
                            <i class="fas fa-exclamation-circle"></i>
                        </button>
                        <button class="btn btn-sm ml-1" type="button"
                            :class="desabilitar('resolver-recepcao') ? 'btn-outline-secondary' : 'btn-success'"
                            data-toggle="tooltip" data-placement="top" title="Solucionar Pendência"
                            :disabled="desabilitar('resolver-recepcao')" @click="solucionar_pendencia ()">
                            <i class="fas fa-check"></i>
                        </button>
                        <button class="btn btn-sm ml-1" type="button"
                            :class="desabilitar('cancelar-envio') ? 'btn-outline-secondary' : 'btn-danger'"
                            data-toggle="tooltip" data-placement="top" title="Retornar para recepção"
                            :disabled="desabilitar('cancelar-envio')" @click="cancelar_protocolo ()">
                            <i class="fas fa-undo-alt"></i>
                        </button>
                        <button class="btn btn-sm ml-1" type="button"
                            :class="desabilitar('enviar') ? 'btn-outline-secondary' : 'btn-primary'"
                            data-toggle="tooltip" data-placement="top" title="Marcar para envio"
                            :disabled="desabilitar('enviar')" @click="receber ()">
                            <i class="fas fa-stamp"></i>
                        </button>
                    </div>
                </template>
                <template v-else>
                    <div class='mr-3'> 
                        <template>

                            <span class="btn-group dropup ml-1">
                                <button class="btn btn-primary btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                                    <i class="fa-solid fa-print"></i>
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="#" v-if="impressao_laudos" @click.prevent="imprimir_laudos()">Laudos</a>
                                    <a class="dropdown-item" href="#" @click.prevent="imprimir_anexos()">Anexos</a>
                                </div>
                            </span>

                            <button v-if="false && impressao_laudos" class="btn btn-sm btn-primary ml-1" title="Imprimir Laudos" type="button" @click="imprimir_laudos()">
                                <i class="fa-solid fa-print"></i>
                            </button>

                            <button class="btn btn-sm ml-1" type="button" 
                                :class="desabilitar('gerarprotocolo') ? 'btn-outline-secondary' : 'btn-primary'"
                                data-toggle="tooltip" data-placement="top" title="Gerar Protocolo Fatura"
                                :disabled="desabilitar('gerarprotocolo')" @click="gerar_protocolo()">
                                <i class="fa-solid fa-file-circle-check"></i>
                            </button>

                            <button class="btn btn-sm ml-1" type="button" 
                                :class="desabilitar('removerprotocolo') ? 'btn-outline-secondary' : 'btn-danger'"
                                data-toggle="tooltip" data-placement="top" title="Remover de Protocolo Fatura"
                                :disabled="desabilitar('removerprotocolo')" @click="remover_protocolo()">
                                <i class="fa-solid fa-file-circle-xmark"></i>
                            </button>

                            <button class="btn btn-sm ml-1" type="button" :class=" desabilitar('cancelar-mov') ? 'btn-outline-secondary' : 'btn-danger' "
                                data-toggle="tooltip" data-placement="top" title="Cancelar Movimentação" :disabled="desabilitar('cancelar-mov')"
                                @click="cancelar_mov()" id="cancelar-mov" v-if="false">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                            <button class="btn btn-sm ml-1" type="button" :class=" desabilitar('glosar') ? 'btn-outline-secondary' : 'btn-danger' "
                                data-toggle="tooltip" data-placement="top" title="Glosar" :disabled="desabilitar('glosar')"
                                @click="glosar_guias()" id="glosar" v-if="false">
                                <i class="fas fa-ban"></i>
                            </button>
                            <button class="btn btn-sm ml-1" type="button" :class=" desabilitar('receber_guia_fatura') ? 'btn-outline-secondary' : 'btn-primary' "
                                data-toggle="tooltip" data-placement="top" title="Atribuir Recebimento"
                                :disabled="desabilitar('receber_guia_fatura')" @click="receber_guia_fatura()"
                                id="receber">
                                <i class="fas fa-donate"></i>
                            </button>
                        </template>

                        <button class="btn btn-sm ml-1" type="button" 
                            v-if="1==0 && $store.state.user.id_usuario == 1"
                            :class="desabilitar('regerar-guia') ? 'btn-outline-secondary' : 'btn-dark'"
                            data-toggle="tooltip" data-placement="top" title="Regerar Guias"
                            :disabled="desabilitar('regerar-guia')" @click="regerar_guias()">
                            <i class="fa-solid fa-retweet"></i>
                        </button>

                        <!-- Recálculos -->

                        <button class="btn btn-sm ml-1" type="button" 
                            :class="desabilitar('recalculo') ? 'btn-outline-secondary' : 'btn-dark'"
                            data-toggle="tooltip" data-placement="top" title="Recalcular Procedimentos"
                            :disabled="desabilitar('recalculo')" @click="recalcular()">
                            <i class="fas fa-calculator"></i>
                        </button>
                        <button class="btn btn-sm ml-1" type="button"
                            :class="desabilitar('contratos') ? 'btn-outline-secondary' : 'btn-dark'"
                            data-toggle="tooltip" data-placement="top" title="Revalidar Contratos"
                            :disabled="desabilitar('contratos')" @click="revalidarContratos()">
                            <i class="fas fa-spell-check"></i>
                        </button>

                        <!-- Mudança de Status de Guia -->

                        <template v-if="$store.state.user.id_usuario == 1">

                            <button class="btn btn-sm btn-primary ml-1" type="button" v-if="!desabilitar('para-auditar')"
                                data-toggle="tooltip" data-placement="top" title="Para Auditar"
                                @click="enviar_para_auditoria ()">
                                <i class="fa-solid fa-clipboard-question"></i>
                            </button>

                            <button class="btn btn-sm btn-primary ml-1" type="button" v-if="!desabilitar('auditado')"
                                data-toggle="tooltip" data-placement="top" title="Auditado"
                                @click="auditado ()">
                                <i class="fa-solid fa-clipboard-check"></i>
                            </button>

                        </template>

                        <button class="btn btn-sm ml-1" type="button"
                            :class="desabilitar('adicionar') ? 'btn-outline-secondary' : 'btn-primary'"
                            data-toggle="tooltip" data-placement="top" title="Adicionar a Fatura"
                            :disabled="desabilitar('adicionar')" @click="adicionarAFatura ()">
                            <i class="fas fa-download"></i>
                        </button>
                        <button class="btn btn-sm ml-1" type="button"
                            :class="desabilitar('remover') ? 'btn-outline-secondary' : 'btn-dark'"
                            data-toggle="tooltip" data-placement="top" title="Remover da Fatura"
                            :disabled="desabilitar('remover')" @click="retirar_da_fatura ()">
                            <i class="fas fa-upload"></i>
                        </button>
                        <button class="btn btn-sm ml-1" type="button"
                            :class="desabilitar('pendencia') ? 'btn-outline-secondary' : 'btn-warning'"
                            data-toggle="tooltip" data-placement="top" title="Adicionar Pendência"
                            :disabled="desabilitar('pendencia')" @click="pendencia ()">
                            <i class="fas fa-exclamation-circle"></i>
                        </button>
                        <button class="btn btn-sm ml-1" type="button"
                            :class="desabilitar('resolver') ? 'btn-outline-secondary' : 'btn-success'"
                            data-toggle="tooltip" data-placement="top" title="Solucionar Pendência"
                            :disabled="desabilitar('resolver')" @click="solucionar_pendencia ()">
                            <i class="fas fa-check"></i>
                        </button>
                        <button class="btn btn-sm ml-1" type="button"
                            :class="desabilitar('cancelar-envio') ? 'btn-outline-secondary' : 'btn-danger'"
                            data-toggle="tooltip" data-placement="top" title="Retornar para recepção"
                            :disabled="desabilitar('cancelar-envio')" @click="cancelar_protocolo ()">
                            <i class="fas fa-undo-alt"></i>
                        </button>
                        <button class="btn btn-sm ml-1" type="button"
                            :class="desabilitar('receber') ? 'btn-outline-secondary' : 'btn-primary'"
                            data-toggle="tooltip" data-placement="top" title="Dar como recebido"
                            :disabled="desabilitar('receber')" @click="receber ()">
                            <i class="far fa-copy"></i>
                        </button>
                        <button class="btn btn-sm ml-1" 
                            :class="desabilitar('criar-fatura') ? 'btn-outline-secondary' : 'btn-success'"
                            type="button"
                            data-toggle="tooltip" data-placement="top" title="Criar fatura"
                            :disabled="desabilitar('criar-fatura')" @click="faturar ()">
                            <i class="fas fa-plus"></i>
                        </button>
                        <button class="btn btn-danger btn-sm ml-1" 
                            type="button"
                            data-toggle="tooltip" data-placement="top" title="Cancelar Definitivo"
                            v-if="!desabilitar('cancelar-definitivo')" @click="cancelar_definitivo ()">
                            <i class="far fa-trash-alt"></i>
                        </button>
                    </div>
                </template>
            </nav>

        </div>

        <div v-else>
            <az-empty-state 
                :icon="firstLoad ? '' : 'fas fa-sync-alt'" 
                :msg="firstLoad ? 'Nenhuma guia encontrada.' : 'Clique no ícone para atualizar a busca.'"
                :action="firstLoad ? '' : 'Buscar'"
                :method="load"></az-empty-state>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addToFaturaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="faturas">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Selecione a Fatura
                            <span v-if="operadora_selecionada" class="ml-2">
                                ({{ operadora_selecionada }})
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row mb-3">
                            <div class="col col-12 col-md-8">
                                <az-periodo v-model="filtros_add_fatura" :sync="true" @sync="adicionarAFatura(true)" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="select"
                                    icon="fa fa-building fa-fw"
                                    placeholder="Todas as Unidades..."
                                    :optionsList="$util.unidades_com_tags(false, true)"
                                    optionsData="id_unidade_operacao"
                                    v-model="filtros_add_fatura.id_unidade_operacao" />
                            </div>
                        </div>

                        <div class="list-group" v-if="!$store.state.loading">

                            <table class="table table-sm bg-white table-hover table-borderless table-striped table-hover-fatura">
                            <thead>
                                <tr class="table-secondary">
                                    <th>Fatura</th>
                                    <th>Guias</th>
                                    <th>Emissão</th>
                                    <th>Unidade</th>
                                    <th>Obs</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr href="#" @click.prevent="enviar_adicao_na_fatura (fat)" style="cursor: pointer;"
                                    v-for="(fat, ifs) in faturas" :key="ifs">
                                    <td>{{ fat.id_fatura }}</td>
                                    <td>{{ getQtdGuias(fat) }}</td>
                                    <td>{{ $util.getFormatDate(fat.dt_emissao) }}</td>
                                    <td>{{ getUnidade(fat) }}</td>
                                    <td class="text-truncate text-nowrap" style="max-width: 150px;">{{ fat.st_observacoes }}</td>
                                </tr>
                            </tbody>
                            </table>

                            <!-- <a href="#" @click.prevent="enviar_adicao_na_fatura (fat)" class="list-group-item list-group-item-action"
                                v-for="(fat, ifs) in faturas" :key="ifs">
                                Fatura <strong>{{ fat.id_fatura }}</strong> de {{ $util.getFormatDate(fat.dt_emissao) }} {{ getUnidade(fat) }}
                            </a> -->
                            <li class="list-group-item" v-if="faturas && !faturas.length">
                                Nenhuma fatura localizada.
                            </li>
                        </div>
                        <div v-else> 
                            <div class="mb-2">
                                Adicionando a fatura...
                            </div>
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Paginação -->
        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="guias && ( guias.last_page > 1 || ( !guias.last_page && guias.to >= guias.per_page ) ) && !selected">
            <div class="d-flex">
                <paginate
                    class="mb-0"
                    :page-count="guias.last_page ? guias.last_page : ( guias.current_page + 1 )"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'"
                    :prev-text="'<<'"
                    :next-text="'>>'"
                    :click-handler="paginar">
                </paginate>
            </div>
        </nav>

        <guia-motivo-glosa ref="motivoglosa" :envio="tipo == 'envio'" :status="( tipo == 'envio' ) ? 'PR' : 'PE'" @refresh="load (false)"></guia-motivo-glosa>
        
        <guia-recebimento 
            ref="receber" 
            :envio="tipo == 'envio'" 
            @refresh="load (false)" 
            :callback_buscar="buscar_procolo" 
            :relatorios="relatorios_linkados" />

        <guia-fatura ref="faturar" @refresh="load (false)"></guia-fatura>
        <guia-edicao ref="edicao" :pode_ver_conta="true" @conta="ver_conta" @refresh="load (false)"></guia-edicao>

        <!-- Modal -->
        <div class="modal fade" id="dtMovModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Recebimento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="lead">Confirma realizar o recebimento das guias selecionadas?</p>

                        <az-input
                            label="Data do Recebimento"
                            type="date"
                            required
                            :validade="validate"
                            v-model="dt_retorno" />

                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="salvar_receber_guia_faturas()">Receber</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Dispatch -->
        <az-dispatch ref="dispatchModal" name="guias_gerar_laudos" titulo="Gerando laudos..." @refresh="gerar_multiplos_laudos_fim" />

        <!-- Editar Atendimento -->
        <iniciar-atendimento 
            ref="ini_atd" 
            @refresh="load(false)" />

        <!-- Imprimir Anexos -->
        <guias-imprimir-anexos ref="imprimir_anexos" />

        <!-- Filtros -->
        <crm-filtros ref="filtros" model_type="App\azure\guia" @refresh="atualizar_filtros"/>

        <!-- Conta Lançamentos -->
        <conta-lancamentos ref="conta" :emit_guia="true" :editar_atend="editar_atendimento" @guia="editar" />

        <!-- Cancelar Procedimentos -->
        <cancelar-procedimento ref="canc_atd_proc" />
        
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from 'moment';
import SubMenuFaturamento from './SubMenuFaturamento.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import GuiaMotivoGlosa from '../../tiss/GuiaMotivoGlosa.vue';
import GuiaRecebimento from './GuiaRecebimento.vue';
import GuiaFatura from './GuiaFatura.vue';
import GuiaEdicao from './GuiaEdicao.vue';
import RelatoriosLinkados from '../../relatorios/shared/RelatoriosLinkados.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzDispatch from "../../util/AzDispatch.vue";
import IniciarAtendimento from '../recepcao/IniciarAtendimento.vue';
import GuiasImprimirAnexos from './GuiasImprimirAnexos.vue';
import CrmFiltros from '../crm/CrmFiltros.vue';
import ContaLancamentos from '../internacao/ContaLancamentos.vue';
import CancelarProcedimento from '../recepcao/CancelarProcedimento.vue';

import TableTh from '../../shared/table/TableTh.vue';

export default {
    data () { 
        return {
            guias: null,
            filtros: {
                inicio: null,
                fim: null, 
                tipo_data: "", 
                status: "", 
                id_operadora: "", 
                id_plano: "", 
                id_usuario: "", 
                id_unidade_operacao: "", 
                id_contrato_operadora: "", 
                id_classe_procedimento: "", 
                id_recepcao: "",
                id_medico: "",
                id_status_laudo: "", 
                tipo_disponivel: "T",
                periodo: "", 
                mes: "",
                guia_zerada: false, 
                filtro_senha: "", 
                op_filtro: 'PAC',
                texto_laudo: "", 
                codigo: "", 
                sup: "", 
                tipo_filtro_pacote: "", 
            },
            filtros_selec: { 
                status: "?"
            },
            paciente: "", 
            selectAll: false,
            statusList: [
                { id: 'TA', display: 'Todos Ativos' },
                { id: 'FF', display: 'Todos Faturados' },
                { id: 'DI', display: 'Disponível (DI)' },
                { id: 'DT', display: 'Disponível/Seriado (DI/TS)' },
                { id: 'PT', display: 'Protocolado (PT)' },
                { id: 'PF', display: 'Protocolo Fatura (PF)' },
                { id: 'TS', display: 'Tratamento Seriado (TS)' },
                { id: 'AF', display: 'A Faturar (AF)' },
                { id: 'EF', display: 'Em Fatura (EF)' },
                { id: 'FT', display: 'Faturada (FT)' },
                { id: 'PR', display: 'Pendente na Recepção (PR)' },
                { id: 'PE', display: 'Pendente (PE)' },
                { id: 'RC', display: 'Recebido (RC)' },
                { id: 'RP', display: 'Recebido Parcial (RP)' },
                { id: 'GT', display: 'Glosa Total (GT)' },
                { id: 'GP', display: 'Glosa Parcial (GP)' },
                { id: 'PA', display: 'Para Auditoria (PA)' },
                { id: 'AU', display: 'Auditado (AU)' },
                { id: 'CA', display: 'Cancelado (CA)' },
            ],
            pesquisar: "",
            firstLoad: false,
            ordem: "",
            faturas: null, 
            unidade_operacao: "",
            usuarios: [], 
            envio_global: false, 
            canceltoken: null, 
            page: 1, 
            paginacao: null, 
            tem_paginacao: false, 
            progresso: 'N', 
            protocolo_para_imprimir: null, 
            dt_retorno: "", 
            validate: false, 
            exibir_matricula: false, 
            exibir_procedimento: false, 
            show_valor_consumo: false,
            impressao_laudos: false, 
            filtros_add_fatura: null, 
            exibir_protocolo: null, 
            relatorios_linkados: null, 
            status_laudo: null, 
            lista_add_filtros: [], 
        }
    },
    
    props: [ 'status', 'tipo', 'id_operadora', 'mes', 'id_usuario' ],

    components: { 
        AzEmptyState,
        AzInput,
        AzPeriodo, 
        SubMenuFaturamento,
        GuiaMotivoGlosa,
        GuiaRecebimento,
        GuiaFatura,
        TableTh,
        GuiaEdicao, 
        RelatoriosLinkados, 
        PrintExport, 
        CabecalhoGenerico, 
        AzSubmit, 
        AzDispatch,
        IniciarAtendimento, 
        GuiasImprimirAnexos, 
        CrmFiltros, 
        ContaLancamentos, 
        CancelarProcedimento, 
    },

    computed: { 
        protocolo_id: function () { 
            if ( this.pesquisar && this.pesquisar.slice(0,1) == 'P' && !isNaN(this.pesquisar.slice(1)) ) { 
                return this.pesquisar.slice(1);
            }

            return null;
        },

        exibir_responsavel: function () { 
            return ( this.tipo == 'envio' && this.envio_global ) || ( this.filtros.status == 'PR' || this.filtros.status == 'PE' );
        },

        exibicao: function () { 
            if ( !this.guias )
                return [];

            let pesquisar = this.pesquisar;
            let parts = pesquisar.split(' ');
            let match = parts.reduce((total, item) => {
                return total + `.*${item}.*`;
            }, "" );
            let reg = new RegExp(match, 'i');
            let items;
            let ordem = this.ordem;

            if ( pesquisar.substr(0,1).toUpperCase() == 'P' && !isNaN(pesquisar.slice(1,1)) ) { 

                items = this.guias.data;

            } else if ( pesquisar.substr(0,1).toUpperCase() == 'G' && !isNaN(pesquisar.slice(1,1)) ) { 

                items = this.guias.data;

            } else if ( pesquisar.substr(0,1).toUpperCase() == 'S' && !isNaN(pesquisar.slice(1,1)) ) { 

                items = this.guias.data;

            } else if ( pesquisar.substr(0,1).toUpperCase() == 'A' && !isNaN(pesquisar.slice(1,1)) ) { 

                items = this.guias.data;

            } else if ( ( pesquisar.substr(0,1) == '#' || pesquisar.substr(0,1).toUpperCase() == 'P' ) && !isNaN(pesquisar.substr(1)) ) { 

                items = this.guias.data.filter(guia => guia.id_atendimento == pesquisar.substr(1));

            } else if ( pesquisar ) {

                items = this.guias.data.filter(guia => { 
                    return reg.test(guia.atendimento.paciente.st_nome) || 
                        reg.test(guia.guia_formatada) || 
                        reg.test(guia.st_numero) ||
                        reg.test(guia.st_codigo_autorizacao) || 
                        reg.test(guia.nome) || 
                        reg.test(guia.plano.search) || 
                        reg.test(guia.atendimento.medico.st_nome_exibicao) || 
                        ( guia.guia_recebimento && guia.guia_recebimento.protocolo_id == this.pesquisar );
                });

            } else { 

                items = this.guias.data;
                
            }

            if ( this.ordem ) { 
                items = _.sortBy(items, function (item) { 
                    return _.get(item, ordem.name );
                });

                if ( this.ordem.direction == 'desc' ) {
                    items = _.reverse(items); 
                }
            } 
            
            return items;          
        },
        selected: function () { 
            return this.exibicao.findIndex(item => { 
                            return item.selected;
                        }) >= 0 ;
        },
        selecteds: function () { 
            return this.exibicao.filter (item => { 
                return item.selected;
            });
        },
        operadora_selecionada: function () { 
            if ( !this.exibicao )
                return null;

            let operadora = _.uniqBy(this.selecteds, 'id_operadora');

            if ( operadora.length == 1 ) 
                return operadora[0].id_operadora;

            return null;
        },
        valor_total: function () {
            let init = { total: 0, glosado: 0, recebido: 0, a_receber: 0, consumo: 0, a_mais: 0 };

            return this.exibicao.reduce((a, b) => { 
                return { 
                    total: a.total + parseFloat(b.valor_total.total),
                    glosado: a.glosado + parseFloat(b.valor_total.glosado),
                    recebido: a.recebido + parseFloat(b.valor_total.recebido),
                    a_receber: a.a_receber + parseFloat(b.valor_total.a_receber),
                    a_mais: a.a_mais + parseFloat(b.valor_total.a_mais), 
                    consumo: a.consumo + parseFloat(b.valor_total.consumo),
                }
            }, init);
        },
        valor_selecionado: function () { 
            let init = { total: 0, glosado: 0, recebido: 0, a_receber: 0, consumo: 0, a_mais: 0 };

            return this.selecteds.reduce((a, b) => { 
                return { 
                    total: a.total + parseFloat(b.valor_total.total),
                    glosado: a.glosado + parseFloat(b.valor_total.glosado),
                    recebido: a.recebido + parseFloat(b.valor_total.recebido),
                    a_receber: a.a_receber + parseFloat(b.valor_total.a_receber),
                    a_mais: a.a_mais + parseFloat(b.valor_total.a_mais), 
                    consumo: a.consumo + parseFloat(b.valor_total.consumo),
                }
            }, init);
        },

        lista_recepcoes: function () { 
            if ( !this.filtros.id_unidade_operacao ) { 
                return [];
            }

            let unid = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.filtros.id_unidade_operacao);

            if ( unid ) { 
                return unid.recepcaos;
            } else { 
                return [];
            }
        },

        dadosFormatados: function () { 
            return this.exibicao.map(guia => { 
                return { 
                    status: guia.ch_status, 
                    atendimento: guia.id_atendimento, 
                    data: this.$util.getFormatDate (guia.dt_criacao, 'DD/MM/YYYY'),
                    guia: guia.guia_formatada, 
                    tipo: guia.nome, 
                    paciente: guia.atendimento.paciente.st_nome, 
                    medico: guia.id_medico_faturar ? guia.medico_faturar.st_nome_exibicao : guia.atendimento.medico.st_nome_exibicao,
                    unidade: guia.atendimento.unidade_operacao ? guia.atendimento.unidade_operacao.st_sigla : "",
                    operadora: guia.plano.operadora.st_operadora, 
                    plano: guia.plano.st_plano,
                    contrato: guia.id_contrato_operadora, 
                    valor: this.$util.formatMoeda(guia.valor_total.total),
                    glosado: this.$util.formatMoeda(guia.valor_total.glosado),
                    recebido: this.$util.formatMoeda(guia.valor_total.recebido),
                    a_receber: this.$util.formatMoeda(guia.valor_total.a_receber), 
                    a_mais: this.$util.formatMoeda(guia.valor_total.a_mais), 
                }
            });
        }
    },
    watch: { 
        filtros: {
            handler: function () {
                if ( ( this.filtros.inicio ? true : false ) ^ ( this.filtros.fim ? true : false ) ) 
                    return;

                if ( this.firstLoad ) { 
                    // this.load ();
                }
            },
            deep: true,
            immediate: true
        },

        tipo: { 

            handler: function () {
                if ( this.tipo == 'cancelamento' ) { 
                    if ( this.filtros.status != 'AC' ) { 
                        this.filtros.status = 'AC';

                        if ( this.firstLoad )   
                            this.load ();
                    }
                } else { 
                    if ( this.filtros.status == 'AC' ) { 
                        this.filtros.status = '';

                        if ( this.firstLoad )   
                            this.load ();
                    }
                }
            }, 
            deep: true,
            immediate: true

        }
    },
    methods: { 
        buscar_ou_selecionar() { 
            if ( this.pesquisar ) { 

                if ( this.pesquisar.trim().slice(0,1) == 'G' || this.pesquisar.trim().slice(0,1) == 'S' || this.pesquisar.trim().slice(0,1) == 'A' ) { 
                    //
                } else { 
                    if ( !this.exibicao.length || this.pesquisar.trim().slice(0,1) == '#' ) { 
                        this.load();
                        return; 
                    }
                }

            }

            this.onSelectAll (true);

        },

        editar_atendimento (id_atendimento) { 
            this.abrir_atendimento({ id_atendimento: id_atendimento });
        },

        ver_conta (id_internacao) { 
            $('.modal').modal('hide');
            this.$refs.conta.abrir(id_internacao);
        }, 

        atualizar_filtros () { 
            this.lista_add_filtros = ( this.$refs.filtros ? this.$refs.filtros.get_filtros(0) : [] ); 
        },

        incluir_filtro () { 
            this.$refs.filtros.abrir(0); 
        },

        imprimir_anexos () { 
            console.log('guias', this.selecteds);
            this.$refs.imprimir_anexos.abrir(this.selecteds);
        },

        outros_medicos(guia) { 
            let lista = guia.atendimento_procedimento_guias.filter(apg => { 
                    return apg.atendimento_procedimento 
                        && apg.atendimento_procedimento.id_medico 
                        && apg.atendimento_procedimento.id_medico != guia.atendimento.id_medico 
                        && !apg.atendimento_procedimento.medico.fl_agenda_compartilhada;
                })
                .map(apg => { 
                    return apg.atendimento_procedimento.medico.st_nome_exibicao;
                });

            return _.uniq(lista).join(', ');
        },

        filtrar_paciente (paciente) { 
            if ( this.paciente ) { 
                this.paciente = "";
                this.pesquisar = ""; 
            } else { 
                this.paciente = _.cloneDeep(paciente);
                this.pesquisar = paciente.st_nome;
            }

            this.refresh_se_necessario();
        },  

        abrir_atendimento_no_faturamento (id_atendimento) { 
            $('.modal').modal('hide');

            this.$util.load(this, { 
                service: 'marcacoes',
                func: 'show',
                parms: { 
                    id: id_atendimento,
                    by_atendimento: true, 
                },
                loadTo: (marcacao) => { 
                    if ( marcacao && marcacao.id_marcacao ) { 
                        this.$refs.ini_atd.abrir(marcacao, 2);
                    }
                }
            });
        },

        abrir_atendimento (guia) { 
            $('.modal').modal('hide');

            this.$util.load(this, { 
                service: 'marcacoes',
                func: 'show',
                parms: { 
                    id: guia.id_atendimento,
                    by_atendimento: true, 
                },
                loadTo: (marcacao) => { 
                    if ( marcacao && marcacao.id_marcacao ) { 
                        this.$refs.ini_atd.abrir(marcacao, 2);
                    }
                }
            });
        },

        /*
        abrir_atendimento(id_atendimento) { 
            this.$util.abrir_atendimento(this, id_atendimento);
        },
        */

        buscar_procolo (protocolo) { 
            $('.modal').modal('hide');

            this.pesquisar = 'P' + protocolo.id_recebimento;
            this.load();
        },

        gerar_protocolo() { 
            this.$refs.receber.abrir(this.selecteds, true);
        },

        remover_protocolo() { 
            if ( !confirm ('Confirma remover do protocolo as guias selecionadas?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'guias',
                func: 'remover_protocolo',
                dados: { 
                    ids: this.selecteds.filter(item => item.ch_status == 'PF')
                        .map(item => item.id_guia), 
                },
                callback: () => { 
                    this.load(false);
                }
            });
        },

        acao_exames_pendentes(zerar = false, separar = false) { 
            let titulo = zerar ? 'ZERAR' : ( separar ? 'SEPARAR' : 'CANCELAR' );

            if ( titulo == 'CANCELAR' ) { 

                this.$refs.canc_atd_proc.cancelar({}, null, (item) => { 
                    this.$util.atualizar(this, { 
                        service: 'guias',
                        func: 'acao_exames_pendentes',
                        dados: { 
                            ids: this.selecteds.map(item => item.id_guia), 
                            zerar: zerar, 
                            separar: separar,
                            ...item 
                        },
                        callback: () => { 
                            this.load(false);
                        }
                    });
                }); 

                return; 

            }

            if ( !confirm ('Confirma ' + titulo + ' os exames pendentes de amostra das guias selecionadas?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'guias',
                func: 'acao_exames_pendentes',
                dados: { 
                    ids: this.selecteds.map(item => item.id_guia), 
                    zerar: zerar, 
                    separar: separar,
                },
                callback: () => { 
                    this.load(false);
                }
            });
        },

        regerar_guias () { 
            if ( !confirm ('Confirma regerar as guias selecionadas?') ) 
                return;

            this.processar_chunk(this.selecteds, 'regerar_guias');
        },

        copiar_texto(texto, msg = null) { 
            this.$util.copiar_clipboard(this, texto, msg);
        },

        receber_guia_fatura () { 
            this.dt_retorno = this.$util.hoje();
            $('#dtMovModal').modal('show');
        },

        salvar_receber_guia_faturas () { 

            this.$util.atualizar(this, { 
                service: 'faturas', 
                func: 'movimentar', 
                dados: { 
                    guias: this.selecteds.map(item => { 
                        return { 
                            id_guia: item.id_guia, 
                            ch_status: item.ch_status, 
                        };
                    }),
                    reapresentacao: false, 
                    tipo: 'RC', 
                    dt_retorno: this.dt_retorno,
                },
                reload: true,
                toast: true,
                modal: 'dtMovModal',
            });

        },

        consultar_recebimentos () { 
            this.$refs.receber.consultar({ 
                envio: this.tipo == 'envio',
                tipo: this.tipo, 
                ...this.filtros,
                search: this.pesquisar,
            });
        },

        filtrar_tipo_guia (tipo) { 
            switch (tipo) {
                case 'C': 
                    tipo = 'Consulta';
                    break;

                case 'S': 
                    tipo = 'SADT';
                    break;

                case 'I': 
                    tipo = 'AIH';
                    break;

                case 'H':
                    tipo = 'Honorário Individual';
                    break;

                case 'A':
                    tipo = 'APAC';
                    break;

                case 'B':
                    tipo = 'BPA';
                    break;
            
                default:
                    return;
            }

            this.pesquisar = ( this.pesquisar == tipo ? '' : tipo );
        },

        getUnidade(fat) {

            if(fat.guia_fatura 
                && fat.guia_fatura.guia 
                && fat.guia_fatura.guia.atendimento
                && fat.guia_fatura.guia.atendimento.unidade_operacao) {
                return (fat.guia_fatura.guia.atendimento.unidade_operacao.st_sigla 
                    ? fat.guia_fatura.guia.atendimento.unidade_operacao.st_sigla 
                    : fat.guia_fatura.guia.atendimento.unidade_operacao.st_nome)
            } else return ""

        },

        getQtdGuias(fat) {

            if(fat.guia_faturas){
                return fat.guia_faturas.length;
            } else if ( fat.guia_faturas_count ) { 
                return fat.guia_faturas_count;
            }
            
            return 0;

        },

        recalcular() { 
            
            if ( !confirm ('Confirma recalcular as guias selecionadas?') ) 
                return;

            this.processar_chunk(this.selecteds, 'recalc_valores');

            /*
            this.$util.atualizar(this, { 
                service: 'guias',
                func: 'recalc_valores',
                dados: { 
                    qtd: this.selecteds.length, 
                    guias: this.selecteds.map(item => { 
                        return { 
                            id_guia: item.id_guia,
                        };
                    }), 
                },
                callback: () => { 
                    this.load(false);
                }
            });
            */

        },

        processar_chunk(lista, func) { 

            this.progresso = Math.round( ( ( this.selecteds.length - lista.length ) / this.selecteds.length ) * 100 );

            let items = _.slice(lista, 0, 25);
            lista = _.slice(lista, 25, lista.length);

            this.$store.commit('loading', true);

            this.$util.atualizar(this, { 
                service: 'guias',
                func: func,
                redir_api: true, 
                dados: { 
                    qtd: this.selecteds.length, 
                    parte: items.length,
                    falta: lista.length, 
                    guias: items.map(item => { 
                        return { 
                            id_guia: item.id_guia,
                        };
                    }), 
                },
                continue_loading: lista.length ? true : false, 
                callback: () => { 
                    if ( lista.length ) { 
                        this.processar_chunk(lista, func);
                    } else { 
                        this.progresso = 100;
                        this.load(false);
                        this.progresso = 'N';

                        this.$toast.add({
                            severity: "success",
                            summary: "Atenção",
                            detail: "Processo concluído.",
                            life: 3000
                        });
                    }
                }

            });



        },

        revalidarContratos() { 

            if ( !confirm ('Confirma revalidar os contratos das guias selecionadas?') ) 
                return;

            this.processar_chunk(this.selecteds, 'recalc_contratos');

            /*
            this.$util.atualizar(this, { 
                service: 'guias',
                func: 'recalc_contratos',
                dados: { 
                    qtd: this.selecteds.length, 
                    guias: this.selecteds.map(item => { 
                        return { 
                            id_guia: item.id_guia,
                        };
                    }), 
                },
                callback: () => { 
                    this.load(false);
                }
            });
            */

        },

        refresh_se_necessario() { 
            if ( this.tem_paginacao ) { 
                // this.load(false);
            }
        },

        paginar (page) {
            this.page = page;
            this.load(false);
        },

        ajustar_fim() { 
            if ( !this.firstLoad )
                return;

            if ( this.filtros.inicio )
                this.filtros.fim = this.filtros.inicio;
        },

        adicionarAFatura (refresh = false) { 
            if ( !refresh ) { 

                console.log('UO', _.get(this.selecteds, '0.atendimento.unidade_operacao.id_unidade_operacao'));
                console.log('selected', this.selecteds);

                this.filtros_add_fatura = { 
                    periodo: 'm',
                    id_unidade_operacao: _.get(this.selecteds, '0.atendimento.unidade_operacao.id_unidade_operacao')
                        ? _.get(this.selecteds, '0.atendimento.unidade_operacao.id_unidade_operacao')
                        : '', 
                };

            }

            this.$store.commit('loading', true);

            this.filtros_add_fatura.status = 'FA';
            this.filtros_add_fatura.id_operadora = this.operadora_selecionada;

            this.$util.load(this, { 
                service: 'faturas', 
                parms: { 
                    ...this.filtros_add_fatura, 
                    exibirUnidade: true,
                },
                loadTo: res => { 
                    this.faturas = res;
                    $('#addToFaturaModal').modal('show');
                }
            });

        },
        enviar_adicao_na_fatura (fatura) { 
            this.$util.atualizar(this, { 
                service: 'faturas',
                func: 'adicionar',
                redir_api: true, 
                dados: { 
                    id: fatura.id_fatura,
                    qtd: this.selecteds.length, 
                    guias: this.selecteds.map(item => { 
                        return { 
                            id_guia: item.id_guia,
                        };
                    }), 
                },
                modal: 'addToFaturaModal',
                callback: () => { 
                    this.load(false);
                }
            })
        },

        enviar_para_auditoria () { 

            let msg = this.selecteds.length == 1 ? 'a guia selecionada' : 'as guias selecionadas';

            if ( !confirm('Confirmar enviar ' + msg + ' para auditoria?') ) 
                return; 

            this.$util.atualizar(this, { 
                service: 'guias',
                func: 'enviar_auditoria',
                redir_api: true, 
                dados: { 
                    guias: this.selecteds.map(item => item.id_guia), 
                },
                callback: () => { 
                    this.load(false);
                }
            });

        },

        auditado () { 

            let msg = this.selecteds.length == 1 ? 'a guia selecionada' : 'as guias selecionadas';

            if ( !confirm('Confirmar marcar ' + msg + ' como auditada?') ) 
                return; 

            this.$util.atualizar(this, { 
                service: 'guias',
                func: 'enviar_auditoria',
                redir_api: true, 
                dados: { 
                    guias: this.selecteds.map(item => item.id_guia), 
                    status: 'AU', 
                },
                callback: () => { 
                    this.load(false);
                }
            });

        },

        retirar_da_fatura () { 
            let msg = this.selecteds.length == 1 ? 'a guia selecionada' : 'as guias selecionadas';

            if ( !confirm('Confirmar remover ' + msg + ' da fatura?') ) 
                return; 

            this.$util.atualizar(this, { 
                service: 'guias',
                func: 'retirar',
                redir_api: true, 
                dados: { 
                    guias: this.selecteds, 
                },
                callback: () => { 
                    this.load(false);
                }
            });
        },

        cancelar_definitivo() { 
            let msg = this.selecteds.length == 1 ? 'a guia selecionada' : 'as guias selecionadas';

            if ( !confirm('Confirmar o cancalemento definitivo d' + msg + ' ?') ) 
                return; 

            this.$util.atualizar(this, { 
                service: 'guias',
                func: 'cancelar_guias_definitivo',
                dados: { 
                    ids: this.selecteds.filter(item => item.ch_status == 'CA')
                        .map(item => item.id_guia), 
                },
                callback: () => { 
                    this.load(false);
                }
            });
        },

        desabilitar (botao) { 
            if ( this.$store.state.loading )
                return true;

            if ( botao == 'auditado' ) { 
                return !this.exibicao.length 
                    || !this.exibicao.find(item => { 
                        return item.selected;
                    })
                    || this.exibicao.find(item => { 
                        return item.selected && item.ch_status != 'PA';
                    });
            } else if ( botao == 'para-auditar' ) { 
                return !this.exibicao.length 
                    || !this.exibicao.find(item => { 
                        return item.selected;
                    })
                    || this.exibicao.find(item => { 
                        return item.selected && item.ch_status != 'AF';
                    });
            } else if ( botao == 'cancelar-definitivo' ) { 
                return !this.exibicao.length 
                    || !this.exibicao.find(item => { 
                        return item.selected;
                    })
                    || this.exibicao.find(item => { 
                        return item.selected && item.ch_status != 'CA';
                    });
            } else if ( botao == 'gerarprotocolo' ) { 
                return !this.exibicao.length 
                    || !this.exibicao.find(item => { 
                        return item.selected;
                    })
                    || this.exibicao.find(item => { 
                        return item.selected && item.ch_status != 'DI' && item.ch_status != 'TS' && item.ch_status != 'PT' && item.ch_status != 'AF';
                    });
            } else if ( botao == 'removerprotocolo' ) { 
                return !this.exibicao.length 
                    || !this.exibicao.find(item => { 
                        return item.selected;
                    })
                    || this.exibicao.find(item => { 
                        return item.selected && item.ch_status != 'PF';
                    });
            } else if ( botao == 'regerar-guia' ) { 
                return !this.exibicao.length 
                    || !this.exibicao.find(item => { 
                        return item.selected;
                    })
                    || this.exibicao.find(item => { 
                        return item.selected && item.ch_status != 'DI' && item.ch_status != 'TS';
                    });
            } else if (botao == "receber_guia_fatura") {
                return (
                this.selecteds.length == 0 ||
                    this.selecteds.find(item => {
                        return item.selected 
                            && item.ch_status != "FT"; 
                    })
                );
            } else if ( botao == 'contratos' ) { 
                return this.exibicao.findIndex(item => { 
                    return item.selected && item.ch_status != 'DI' && item.ch_status != 'AF' && item.ch_status != 'TS'
                        && item.ch_status != 'PR' && item.ch_status != 'PT' && item.ch_status != 'PE' && item.ch_status != 'PF';
                }) >= 0;
            } else if ( botao == 'recalculo' ) { 
                return this.exibicao.findIndex(item => { 
                    return item.selected && (item.ch_status == 'PA' || item.ch_status == 'AU');
                }) >= 0;
            } else if ( botao == 'adicionar' ) { 
                return !this.operadora_selecionada || this.exibicao.findIndex(item => { 
                    return item.selected && item.ch_status != 'AF' && item.ch_status != 'PF';
                }) >= 0;
            } else if ( botao == 'remover' ) { 
                return !this.operadora_selecionada || this.exibicao.findIndex(item => { 
                    return item.selected && item.ch_status != 'EF';
                }) >= 0;
            } else if ( botao == 'enviar' ) { 
                return this.tipo != 'envio' || this.exibicao.findIndex(item => { 
                    return item.selected && item.ch_status != 'DI' && item.ch_status != 'TS';
                }) >= 0;
            } else if ( botao == 'cancelar-envio' ) { 
                return this.exibicao.findIndex(item => { 
                    return item.selected && item.ch_status != 'PT' && item.ch_status != 'AF' && item.ch_status != 'DI' && item.ch_status != 'TS';
                }) >= 0;
            } else if ( botao == 'pendencia' ) { 
                return this.exibicao.findIndex(item => { 
                    return item.selected && item.ch_status != 'AF' && item.ch_status != 'PE' && item.ch_status != 'PF';
                }) >= 0;
            } else if ( botao == 'pendencia-recepcao' ) { 
                return this.tipo != 'envio' || this.exibicao.findIndex(item => { 
                    return item.selected && item.ch_status != 'DI' && item.ch_status != 'PR' && item.ch_status != 'TS';
                }) >= 0;
            } else if ( botao == 'resolver-recepcao' ) { 
                return this.tipo != 'envio' || this.exibicao.findIndex(item => { 
                    return item.selected && item.ch_status != 'PR';
                }) >= 0;
            } else if ( botao == 'resolver' ) { 
                return this.exibicao.findIndex(item => { 
                    return item.selected && item.ch_status != 'PE';
                }) >= 0;
            } else if ( botao == 'receber' ) { 
                return this.exibicao.findIndex(item => { 
                    return item.selected && item.ch_status != 'DI' && item.ch_status != 'PT' && item.ch_status != 'TS';
                }) >= 0;
            } else if ( botao == 'criar-fatura' ) { 
                return !this.operadora_selecionada || this.exibicao.findIndex(item => { 
                    return item.selected && item.ch_status != 'AF' && item.ch_status != 'PF';
                }) >= 0;
            } else if ( botao == 'cancelar-exames' ) { 
                return this.exibicao.findIndex(item => { 
                    return item.selected 
                        && item.ch_status != 'PR' && item.ch_status != 'PE' && item.ch_status != 'PF'
                        && item.ch_status != 'TS' && item.ch_status != 'AF' && item.ch_status != 'PT'
                        && item.ch_status != 'DI';
                }) >= 0;
            }
        },
        ordenar (campo) { 
            this.ordem = campo;
        },
        onSelectAll (force = false) { 
            if ( this.pesquisar.substr(0,1).toUpperCase() == 'G' && !isNaN(this.pesquisar.substr(1)) ) { 
                
                let guia = this.exibicao.find(guia => guia.id_guia == this.pesquisar.substr(1));

                if ( guia ) { 

                    let info = "\n" + guia.atendimento.paciente.st_nome + "\n" + guia.guia_formatada;

                    if ( guia.selected ) { 
                        this.$toast.add({ 
                            severity: "info",
                            summary: "Atenção",
                            detail: "Guia já selecionada: " + this.pesquisar + info,
                            life: 5000         
                        });    
                    } else { 
                        guia.selected = true;

                        this.$toast.add({ 
                            severity: "success",
                            summary: "Atenção",
                            detail: "Guia selecionada: " + this.pesquisar + info,
                            life: 2500         
                        });    
                    }
                } else { 
                    this.$toast.add({ 
                        severity: "error",
                        summary: "Atenção",
                        detail: "Guia não identificada: " + this.pesquisar,
                        life: 5000         
                    });
                }

                this.$nextTick(() => { 
                    this.pesquisar = "";
                });

                return;

            } else if ( this.pesquisar.substr(0,1).toUpperCase() == 'A' && !isNaN(this.pesquisar.substr(1)) ) { 
                
                let guias = this.exibicao.filter(guia => guia.id_atendimento == this.pesquisar.substr(1));

                if ( guias && guias.length ) { 

                    guias.forEach(guia => { 

                        let info = "\n" + guia.atendimento.paciente.st_nome + "\n" + guia.guia_formatada;

                        if ( guia.selected ) { 
                            this.$toast.add({ 
                                severity: "info",
                                summary: "Atenção",
                                detail: "Guia já selecionada: " + this.pesquisar + info,
                                life: 5000         
                            });    
                        } else { 
                            guia.selected = true;

                            this.$toast.add({ 
                                severity: "success",
                                summary: "Atenção",
                                detail: "Guia selecionada: " + this.pesquisar + info,
                                life: 2500         
                            });    
                        }

                    });

                } else { 

                    this.$toast.add({ 
                        severity: "error",
                        summary: "Atenção",
                        detail: "Guia não identificada: " + this.pesquisar,
                        life: 5000         
                    });

                }

                this.$nextTick(() => { 
                    this.pesquisar = "";
                });

                return;

            } else if ( this.pesquisar.substr(0,1).toUpperCase() == 'S' && !isNaN(this.pesquisar.substr(1)) ) { 

                this.load(false);
                return;

            }

            let selected = force ? force : this.selectAll;
            _.forEach(this.exibicao, element => {
                    element.selected = selected;
                });
            this.$nextTick(() => {
                this.$forceUpdate ();
            });
        },
        select_item () { 
            this.selectAll = false;
            this.$forceUpdate ();
        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
        pendencia () { 
            this.$refs.motivoglosa.abrir(this.selecteds);
        },
        solucionar_pendencia () { 
            this.$refs.motivoglosa.solucionar(this.selecteds);
        },
        receber () { 
            if ( this.$refs.linkados && this.$refs.linkados.relatorios ) { 
                this.relatorios_linkados = this.$refs.linkados.relatorios;
            }

            this.$refs.receber.abrir(this.selecteds);
        },
        cancelar_protocolo () { 
            this.$refs.motivoglosa.abrir(this.selecteds, 'PR');
        },
        faturar () { 
            this.$refs.faturar.abrir(this.selecteds);
        },
        editar (guia) { 
            this.$refs.edicao.abrir(guia);
        },
        load(showSpinner = true) { 
            /*
            if ( this.tipo == 'envio' && !this.filtros.status ) { 
                this.guias = null;
                return;
            }
            */

            if ( !this.filtros.id_operadora ) { 
               this.filtros.id_contrato_operadora = "";
               this.filtros.id_plano = "";
            }

            this.protocolo_para_imprimir = null;
            
            this.$store.commit('loading', true);

            if ( showSpinner )
                this.guias = null;

            let query = { q: [ 
                { 
                    name: 'guias.index', 
                    id: 'guias', 
                    parms: { 
                        paralista: true, 
                        envio: this.tipo == 'envio',
                        tipo: this.tipo, 
                        ...this.filtros,
                        page: this.page,
                        size: 1000,
                        pesquisar: this.pesquisar, // this.tem_paginacao ? this.pesquisar : null, 
                        id_paciente: this.paciente ? this.paciente.id_pessoa : null, 
                        exibir_matricula: this.exibir_matricula, 
                        exibir_procedimento: this.exibir_procedimento, 
                        exibir_protocolo: this.exibir_protocolo, 
                        add_filtros: this.lista_add_filtros, 
                    }
                },
                { 
                    name: 'usuarios.tem_permissao', 
                    id: 'tem_permissao', 
                    parms: { 
                        id_acao: 11, 
                    }
                },
            ]};

            if ( this.filtros.id_status_laudo ) { 

                query.q.push({ 
                    name: 'status_laudos.index', 
                    id: 'status_laudo', 
                    parms: { 
                        where: { 
                            id_status_laudo: this.filtros.id_status_laudo, 
                        }
                    }
                });

            }

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();
                                    
            this.axios.post('/aql?a=guias.index&page=' + this.page, query, {
                    cancelToken: this.canceltoken.token
                })
                .then(res => { 
                    if ( !res || !res.data )
                        return;

                    this.selectAll = false;

                    if ( res.data.guias.status == 200 ) { 

                        this.filtros_selec = _.cloneDeep(this.filtros);

                        this.guias = res.data.guias.data;

                        if ( this.guias.last_page < this.page && this.page > 1 ) { 
                            this.page = 1;
                        } else if ( !this.guias.last_page && this.guias.current_page > 1 && !this.guias.from && !this.guias.to ) { 
                            this.page = 1;
                        }

                        if ( this.guias.last_page > 1 ) { 
                            this.tem_paginacao = true;
                        }

                        if ( this.guias.total && this.pesquisar.substr(0,1).toUpperCase() == 'P' && !isNaN(this.pesquisar.substr(1)) ) { 
                            this.protocolo_para_imprimir = { id_recebimento: this.pesquisar.substr(1) };
                        }

                    }

                    if ( res.data.status_laudo && res.data.status_laudo.status == 200 ) { 
                        this.status_laudo = ( res.data.status_laudo.data && res.data.status_laudo.data[0] ) 
                            ? res.data.status_laudo.data[0] 
                            : null;
                    } else { 
                        this.status_laudo = null; 
                    }

                    if ( res.data.tem_permissao.status == 200 ) { 
                        this.envio_global = res.data.tem_permissao.data.pode;
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                    this.firstLoad = true;
                });
        },
        getFormatDate (date, format) { 
            return moment(date, 'YYYY-MM-DD').format(format);
        },

        confirmarCancelamento (cancelar) { 
            this.$util.atualizar (this, { 
                service: 'guias', 
                func: 'confirmar_cancelamento',
                dados: { 
                    guias: this.selecteds,
                    cancelar: cancelar,
                },
                callback: () => { 
                    this.load(false);
                }
            });
        },

        imprimir_laudos() {

            if(!this.selecteds || this.selecteds.length == 0) {
                return;
            }
            const idGuias = this.selecteds.map(guia => {
                return guia.id_guia;
            });

            const jobId = this.$util.uuidv4();

            this.$refs.dispatchModal.executar_com_progresso(
                "gerar_multiplos_laudos",
                "guias",
                {
                    guias: idGuias,
                    job_id: jobId
                },
                'processar-' + jobId,
                'processar-' + jobId + "-progresso",
                true
            );
            
        },

        gerar_multiplos_laudos_fim(res) {
            console.log('res', res);

            if (res && res.data && res.data.token) {
                this.$util.print_preview('/imprimir/guia/laudo', false, { "token": res.data.token }); 
                return;  
            }

            if (res && res.data && res.data.erro) {
                this.$toast.add({
                    severity: "error",
                    summary: "Erro",
                    detail: res.data.msg ? res.data.msg : "Erro ao gerar laudos",
                    life: 5000
                });
            }
            
        }
        
    },
    beforeMount () {  

        this.filtros.status = 'DI';

        if ( this.$route.params.status ) { 
            
            this.filtros.status = this.$route.params.status;
            this.filtros.id_operadora = this.$route.params.id_operadora ? this.$route.params.id_operadora : '';
            this.filtros.id_unidade_operacao = this.$route.params.id_unidade_operacao ? this.$route.params.id_unidade_operacao : '';
            this.filtros.id_recepcao = this.$route.params.id_recepcao ? this.$route.params.id_recepcao : '';

            if ( ( this.filtros.status == 'PE' ) && this.id_usuario ) { 
                this.filtros.id_usuario = this.id_usuario;
            }

            if ( this.$route.params.periodo ) { 

                this.filtros.periodo = this.$route.params.periodo;
                this.filtros.mes = this.$route.params.mes;
                this.filtros.semana = this.$route.params.semana;
                this.filtros.inicio = this.$route.params.inicio;
                this.filtros.fim = this.$route.params.fim;

            }

        } else { 

            if ( this.tipo == 'envio' ) { 
                this.filtros.inicio = moment().subtract(5, "days").format('YYYY-MM-DD');
            } else { 
                this.filtros.inicio = moment().subtract(5, "days").format('YYYY-MM-DD');
            }

            this.filtros.fim = moment().format('YYYY-MM-DD');

            this.filtros.periodo = '';
        }

        if ( !this.$route.params.periodo && this.$route.params.inicio ) { 
            this.filtros.inicio = this.$route.params.inicio;
            this.filtros.periodo = '';
        }

        if ( !this.$route.params.periodo && this.$route.params.fim ) { 
            this.filtros.fim = this.$route.params.fim;
            this.filtros.periodo = '';
        }

        if ( this.tipo == 'envio' ) { 
            this.statusList = [
                { id: 'DI', display: 'Disponível' },
                { id: 'DT', display: 'Disponível/Trat. Seriado' },
                { id: 'PT', display: 'Protocolada' },
                { id: 'PR', display: 'Pendente' },
                { id: 'TS', display: 'Tratamento Seriado' },
            ];

            this.filtros.status = 'DI';  
            
            if ( !this.$route.params.sem_ck ) { 
                this.filtros.id_unidade_operacao = this.$util.getCookie('id_unidade_operacao');
            }

            if ( this.id_usuario ) { 
                this.filtros.id_usuario = this.id_usuario;
                this.filtros.status = 'PR';       
            }
        } else if ( this.tipo == 'auditoria' ) { 

            this.statusList = [
                { id: 'PA', display: 'Para Auditoria (PA)' },
                { id: 'AU', display: 'Auditado (AU)' },
            ];

            this.filtros.status = 'PA';  
            
            if ( !this.$route.params.sem_ck ) { 
                this.filtros.id_unidade_operacao = this.$util.getCookie('id_unidade_operacao');
            }

            if ( this.id_usuario ) { 
                this.filtros.id_usuario = this.id_usuario;
                this.filtros.status = 'PA';       
            }

        } else if ( this.tipo == 'cancelamento' ) { 

            this.filtros.status = 'AC';       

        }
                
    },
    mounted () { 

        this.exibir_matricula = this.$util.getCookie('fat-em') == 'S' ? true : false; 
        this.exibir_procedimento = this.$util.getCookie('fat-ep') == 'S' ? true : false; 
        this.exibir_protocolo = this.$util.getCookie('fat-ept') == 'S' ? true : false; 

        if ( this.tipo == 'envio' ) { 

            if ( this.$route.path == '/internacao/envio' ) { 
                
                this.$store.commit('setBreadcrumb', 
                    [
                        { name: "Internação", path: "/internacao/internados"},
                        { name: "Protocolo de Envio", path: "/internacao/envio"}
                    ]);    

            } else {

                this.$store.commit('setBreadcrumb', 
                    [
                        { name: "Recepção", path: "/recepcao"},
                        { name: "Protocolo de Envio da Recepção", path: "/recepcao/envio"}
                    ]);

            }

        } else if ( this.tipo == 'auditoria' ) { 

            this.$store.commit('setBreadcrumb', [
                { name: "Auditoria de Conta", path: "/auditoria/conta"}
            ]);

        } else {
            this.$store.commit('setBreadcrumb', 
                [
                    { name: "Faturamento", path: "/faturamento/visao"},
                    { name: "Guias", path: "/faturamento/guias"},
                ]);
        }

        if ( this.$route.params.buscar ) { 

            this.$store.commit('loading', true);
            this.load ();

        } else { 

            if ( this.$route.params.search ) { 

                const ids = this.$route.params.search.match(/#[0-9]+/gi);

                if ( this.$route.params.search.toUpperCase().indexOf('FAT') >= 0 ) { 

                    if ( ids ) { 
                        this.$router.push({ name: 'faturas', params: { id_fatura: ids[0].substr(1) } });
                    } else { 
                        this.$router.push({ name: 'faturas' });    
                    }

                } else { 

                    this.pesquisar = ids[0];
                    this.$store.commit('loading', true);
                    this.load();

                }

            }

        }

        let query = {
        q: [
          {
            name: "configuracoes.check",
            id: "impressao_laudos",
            parms:  {
              st_slug: "impressao-laudos-faturamento",
              st_valor: "1",
            }
          }
          
        ]
      }

      this.axios.post('/aql', query)
        .then(res => {
          
          if(res.data.impressao_laudos.status == 200) {
            this.impressao_laudos = res.data.impressao_laudos.data
          }

        })
        .finally(() => {
          this.$store.commit('loading', false);
        })

    },
    
    updated() {
        $('[data-toggle="tooltip"]').tooltip();
    },
}
</script>



